import * as Yup from 'yup';

export default Yup.object().shape({
   email: Yup.string().email('Invalid email').required('Заповніть це поле')
      .max(255, "Максимальна кількість символів досягнута")
});